import axios from 'axios';

export const getAlgoliaToken = async () => {
  try {
    const { data } = await axios.get(process.env.GATSBY_ALGOLIA_TOKEN_URL, { withCredentials: true });
    return data?.apiKey || null;
  } catch (error) {
    console.error(error);
    return null;
  }
};
